import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class Ad4dCdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [
		DeviceModel.AD4D,
		DeviceModel.AD4DA,
		DeviceModel.AD4DB,
		DeviceModel.AD4DC,
		DeviceModel.AD4DD,
		DeviceModel.AD4DE,
		DeviceModel.AD4DF,
		DeviceModel.AD4DP55,
		DeviceModel.AD4DR52
	];

	public hideIdentifyAllButton(): boolean {
		return true;
	}

	public hideIpConfiguration(): boolean {
		return true;
	}
}
